import { render, staticRenderFns } from "./TextPred.vue?vue&type=template&id=0c87f71c&scoped=true&"
import script from "./TextPred.vue?vue&type=script&lang=js&"
export * from "./TextPred.vue?vue&type=script&lang=js&"
import style0 from "./TextPred.vue?vue&type=style&index=0&id=0c87f71c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c87f71c",
  null
  
)

component.options.__file = "TextPred.vue"
export default component.exports